import { action } from 'store/store.utils'

export const REMOVE_ERROR_NOTIFICATION = 'REMOVE_ERROR_NOTIFICATION'

export const removeErrorNotification = (name: string) => action(REMOVE_ERROR_NOTIFICATION, name)
export type RemoveErrorNotification = ReturnType<typeof removeErrorNotification>
